export const BreadCrumb = (props) => {
    const label = props.label;
    const uri = window.location.href;
    const params = uri.split('/');
    let link;
    switch (label) {
        case 'archives':
        case 'categories':
        case 'characters':
        case 'experiments':
        case 'festivals':
        case 'history':
        case 'origins':
        case 'outlinks':
        case 'park':
        case 'rendez-vous':
            if (label === 'archives')
                link = { href: '/', name: 'home', item: 'archves des attractons' };
            if (label === 'categories')
                link = { href: '/', name: 'home', item: 'categories et famille' };
            if (label === 'characters')
                link = { href: '/', name: 'home', item: 'personnages des parcs' };
            if (label === 'experiments')
                link = { href: '/', name: 'home', item: 'Experiences de stitch' };
            if (label === 'festivals')
                link = { href: '/', name: 'home', item: 'festivals' };
            if (label === 'history')
                link = { href: '/', name: 'home', item: 'Historique' };
            if (label === 'origins')
                link = { href: '/', name: 'home', item: 'films et series' };
            if (label === 'outlinks')
                link = { href: '/', name: 'home', item: 'Liens externes' };
            if (label === 'park')
                link = { href: '/', name: 'home', item: params[3] };
            if (label === 'rendez-vous')
                link = { href: '/', name: 'home', item: 'rendez-vous' };
            return (
                <div className="breadcrumb">
                    <a href={link.href} alt={link.name}>{link.name}</a>
                    <i className="fa fa-circle"></i>
                    <span>{link.item}</span>
                </div>
            )
        case 'archive':
        case 'category':
        case 'experiment':
        case 'family':
        case 'origin':
        case 'personnage':
        case 'rendez-vous-personnage':
        case 'univers':
            if (label === 'archive')
                link = { href: '/archives-des-attractions', name: 'Archives des attractions', item: params[7] };
            if (label === 'category' || label === 'family')
                link = { href: '/categories-et-familles', name: 'Catégories et Familles', item: params[4] };
            if (label === 'experiment')
                link = { href: '/experiences', name: 'Expériences', item: params[5] };
            if (label === 'origin')
                link = { href: '/films-et-series', name: 'Films et Séries', item: params[4] };
            if (label === 'personnage')
                link = { href: '/personnages', name: 'Personnages', item: params[5] };
            if (label === 'rendez-vous-personnage')
                link = { href: '/rendez-vous', name: 'Rendez-vous', item: params[5] };
            if (label === 'univers')
                link = { href: `/${params[3]}`, name: params[3], item: params[5] };
            return (
                <div className="breadcrumb">
                    <a href={`/`} alt="home">home</a>
                    <i className="fa fa-circle"></i>
                    <a href={link.href} alt={link.name}>{link.name}</a>
                    <i className="fa fa-circle"></i>
                    <span>{link.item}</span>
                </div>
            )
        case 'attraction':
            link = [
                { href: `/`, name: 'home' },
                { href: `/${params[3]}`, name: params[3] },
                { href: `/${params[3]}/univers/${params[5]}`, name: params[5] },
                { item: params[7] }
            ]
            return (
                <div className="breadcrumb">
                    <a href={link[0].href} alt={link[0].name}>{link[0].name}</a>
                    <i className="fa fa-circle"></i>
                    <a href={link[1].href} alt={link[1].name}>{link[1].name}</a>
                    <i className="fa fa-circle"></i>
                    <a href={link[2].href} alt={link[2].name}>{link[2].name}</a>
                    <i className="fa fa-circle"></i>
                    <span>{link[3].item}</span>
                </div>
            )
        default:
            return (
                <></>
            )

    }
}
